import { render, staticRenderFns } from "./RoomTable.vue?vue&type=template&id=5dc39c8a&scoped=true&"
import script from "./RoomTable.vue?vue&type=script&lang=js&"
export * from "./RoomTable.vue?vue&type=script&lang=js&"
import style0 from "./RoomTable.vue?vue&type=style&index=0&id=5dc39c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc39c8a",
  null
  
)

export default component.exports